import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

/**
 * プログレストラッカー1
 */
const ErrorIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="157"
      height="9"
      viewBox="0 0 157 9"
    >
      <rect
        width="150"
        height="1"
        rx="0.5"
        transform="translate(0 4)"
        fill={CLIENT_SETTINGS.colors.main}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(74)"
        fill={CLIENT_SETTINGS.colors.main}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(37)"
        fill={CLIENT_SETTINGS.colors.main}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(111)"
        fill={CLIENT_SETTINGS.colors.main}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(148)"
        fill={CLIENT_SETTINGS.colors.main}
      />
      <g
        fill={CLIENT_SETTINGS.colors.textForMainBackground}
        stroke={CLIENT_SETTINGS.colors.main}
        strokeWidth="3"
      >
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
        <circle cx="4.5" cy="4.5" r="3" fill="none" />
      </g>
    </svg>
  )
}

export default ErrorIcon
